import { render } from "./VanillaD.vue?vue&type=template&id=32e4e147&scoped=true"
import script from "./VanillaD.vue?vue&type=script&lang=js"
export * from "./VanillaD.vue?vue&type=script&lang=js"

import "./VanillaD.vue?vue&type=style&index=0&id=32e4e147&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e4e147"]])

export default __exports__